import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { jewelstepsHeaderLogoPath, jewelstepsLoginLogoPath, jewelstepsLoginRightLogoPath, swarnAppHeaderLogoPath, swarnAppLoginLogoPath, swarnAppLoginRightLogoPath, swarnAppMainUrl } from '../utils/comon-utils';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  //#region  dynamic set svg path variable
  logoLogin  :string;
  logoHeader :string;
  logoLoginRight :string;
  displayDefaultCompanyIcon
  //#endregion

  public config = {
    settings: {
      layout: 'Dubai',
      layout_type: 'ltr',
      layout_version: 'light-only',
      sidebar_type: 'default-sidebar',
      icon: 'stroke-svg'
    },
    color: {
      primary_color: '#5047FF', 
      secondary_color: '#f73164'
    }
  }

  constructor(private titleService: Title) { 
    if(this.config.settings.layout_type == 'rtl')
      document.getElementsByTagName('html')[0].setAttribute('dir', this.config.settings.layout_type);

    document.documentElement.style.setProperty('--theme-deafult', this.config.color.primary_color);
    document.documentElement.style.setProperty('--theme-secondary', this.config.color.secondary_color);


    //#region url wise assing svg path and company name
      if( environment.baseUrl == swarnAppMainUrl){
          document.documentElement.style.setProperty('--providedCompanyName', "'SwarnApp CRM'");
          this.logoLogin  = swarnAppLoginLogoPath;
          this.logoLoginRight = swarnAppLoginRightLogoPath;
          this.logoHeader =  swarnAppHeaderLogoPath;
          this.displayDefaultCompanyIcon = swarnAppHeaderLogoPath;
          this.titleService.setTitle("SwarnApp CRM");
      } else {
          document.documentElement.style.setProperty('--providedCompanyName', "'Jewelsteps CRM'");
          this.logoLogin = jewelstepsLoginLogoPath;
          this.logoLoginRight = jewelstepsLoginRightLogoPath;
          this.logoHeader = jewelstepsHeaderLogoPath; 
          this.displayDefaultCompanyIcon = jewelstepsHeaderLogoPath;
          this.titleService.setTitle("Jewelsteps CRM");
      }
    //#endregion
  }


}
